import { configFactory } from '../utils';

export default configFactory({
  development: {
    uri: process.env.REACT_APP_GQL_SVC_URL,
    credentials: 'same-origin'
  },
  production: {
    uri: process.env.REACT_APP_GQL_SVC_URL,
    credentials: 'same-origin'
  },
});
